import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const Avatar = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: 50%;
`;

export const AssistantName = styled.div`
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  font-size: ${({ theme }) => theme.font.size.default};
  color: ${({ theme }) => theme.color.assistantMessage};
`;

export const AiBadge = styled.div`
  margin-left: auto;
  font-size: ${({ theme }) => theme.font.size.small};
  width: 1.75rem;
  height: 1.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000000;
  color: ${({ theme }) => theme.color.assistantMessage};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
`;

